import classNames from 'classnames';
import { type ReactNode, useMemo } from 'react';
import { COPY } from '../../assets/copy/copy';
import { HourglassEmptyIcon, HourglassIcon } from '../../assets/svgs/index.js';
import { isValidDate } from '../../utils/validators';
import styles from './StatusIcon.module.scss';

export type ExpiringSoonProps = {
  expiringDate: Date | string | number;
};

export function ExpiringSoonIcon(props: ExpiringSoonProps): JSX.Element {
  const date = new Date(props.expiringDate);
  const todaysDate = new Date(Date.now());
  const days = Math.floor(
    (date.getTime() - todaysDate.getTime()) / (1000 * 3600 * 24)
  );
  const { expiresIn, icon } = useMemo(() => {
    if (days >= 0) {
      switch (days) {
        case 0:
          return {
            expiresIn: <span>{COPY.MISSIONS.EXPIRING_TODAY}</span>,
            icon: <HourglassIcon />,
          };
        case 1:
          return {
            expiresIn: <span>{COPY.MISSIONS.EXPIRING_TOMORROW}</span>,
            icon: <HourglassIcon />,
          };
        default:
          return {
            expiresIn: <span>{COPY.MISSIONS.EXPIRING_IN(days)}</span>,
            icon: <HourglassIcon />,
          };
      }
    } else {
      return {
        expiresIn: <span>{COPY.MISSIONS.EXPIRED}</span>,
        icon: <HourglassEmptyIcon />,
      };
    }
  }, [days]);

  let dateText: ReactNode = COPY.MISSIONS.EXPIRING_SOON_NO_DATE;
  try {
    if (isValidDate(date)) {
      dateText = expiresIn;
    }
  } catch (_error) {
    // Do nothing; use default value
  }

  return (
    <div
      className={classNames(styles['status-icon-component'], 'expiring-soon')}
    >
      {icon}
      {dateText}
    </div>
  );
}
